module.exports = __webpack_public_path__ + "static/media/clientLogo_acqua&sapone.76528f87.png";